<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
      <div class="logo-menu-con">
        <div class="logo-con">
          <img class="logo-img" src="@/assets/logo.png" alt="">
          <p>综合服务平台</p>
        </div>
        <ScrollMenu>
          <el-menu
            :style = "`width:${menuWidth}px`"
            :default-active="activeMenu"
            :collapse="false"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :unique-opened="false"
            :active-text-color="variables.menuActiveText"
            mode="horizontal"
            menu-trigger="hover"
          >
            <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
          </el-menu>
        </ScrollMenu>
      </div>
      <div class="right-actions-container">
        <div class="currentExhibition right-menu-item hover-effect">
          <div class="avatar-wrapper" style="max-width: 200px;">
              <el-tooltip :content="`当前展会：${currentExhibitionName}`" placement="bottom">
                  <span>当前展会：{{ currentExhibitionName.length > 6 ? currentExhibitionName.substring(0, 6) + '...' : (currentExhibitionName || '暂无展会') }}</span>
              </el-tooltip>
          </div>
        </div>
        <div class="exhibition-container right-menu-item hover-effect">
          <div class="avatar-wrapper">
            <span @click="exchangeExhibition">切换展会</span>
            <i class="el-icon-sort" />
          </div>
        </div>
        <div class="avatar-container right-menu-item hover-effect">
          <div class="avatar-wrapper" style="padding: 5px 11px; display: flex; align-items: center; justify-content: space-between; white-space: nowrap; width: auto; min-width: 106px;">
            <el-tooltip :content="currentVenueName" placement="bottom" :disabled="!currentVenueName || currentVenueName.length <= 6">
              <span @click="exchangeVenue">{{ currentVenueName && currentVenueName.length > 6 ? currentVenueName.substring(0, 6) + '...' : currentVenueName }}</span>
            </el-tooltip>
            <i class="el-icon-sort" />
          </div>
        </div>
      </div>
      <ExchangeExhibitionDialog
          :open="openExchangeExhibitionDialog" 
          v-if="openExchangeExhibitionDialog"
          @submit="submitExchangeExhibitionDialog" 
          @cancel="cancelExchangeExhibitionDialog" 
      />
      <SelectVenueDialog
        :open="selectVenueDialogVisible" 
        v-if="selectVenueDialogVisible" 
        @cancel="cancelSelectVenueDialog"
        @submit="submitSelectVenueDialog"
      />
    </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem.vue'
import variables from '@/styles/variables.scss'
import ExchangeExhibitionDialog from '@/views/exhibition/ExchangeExhibitionDialog.vue';
import SelectVenueDialog from '@/views/login/components/SelectVenueDialog.vue';
import { setStep, getVenueCode } from '@/utils/auth';
import ScrollMenu from './ScrollMenu.vue';
import { getCurrentExhibitionApi, switchCurrentExhibitionApi } from "@/api/exhibitionList/index";
import { venueListApi } from "@/api/user";
export default {
  name: 'Headbar',
  components: { SidebarItem,ExchangeExhibitionDialog,SelectVenueDialog,ScrollMenu},
  computed: {
    ...mapGetters([
      'permission_routes',
      'avatar',
      'sidebar',
      'logo',
      'currentExhibitionName',
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables
    },
    menuWidth() {
      const menuwidth = this.permission_routes.filter(item=>!item.hidden).length*96;
      console.log('menuwidth',menuwidth,this.permission_routes)
      return menuwidth;
    },
  },
  data(){
    return{
      currentVenueName: '',
      selectVenueDialogVisible: false,
      openExchangeExhibitionDialog: false,
      isLeftDisabled: true,
      isRightDisabled: false,
      authList: [],
      systemName: ''
    }
  },
  created(){
    this.getCurrentExhibition();
    this.getCurrentVenue();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    submitExchangeExhibitionDialog(data){
      console.log("submitExchangeExhibitionDialog",data)
      this.getCurrentExhibition();
      this.openExchangeExhibitionDialog = false;
    },
    cancelExchangeExhibitionDialog(){
      this.openExchangeExhibitionDialog = false;
    },
    exchangeExhibition(){
      console.log("切换展会")
      this.openExchangeExhibitionDialog = true;
    },
    exchangeVenue(){
      console.log("切换场馆")
      this.openSelectVenueDialog();
    },
    async getCurrentExhibition(){
      let res = await getCurrentExhibitionApi() || {};
      const currentExhibitionName = res.title || "暂无展会";
      this.$store.dispatch('user/setCurrentExhibitionName',currentExhibitionName)

    },
    async getCurrentVenue() {
      try {
        let res = await venueListApi();
        const venueList = res || [];
        const currentCode = getVenueCode();
        const currentObj = venueList.find(item => item.tenantCode === currentCode);
        if (currentObj && currentObj.venueName) {
          this.currentVenueName = currentObj.venueName;
        } else {
          this.currentVenueName = "当前场馆";
        }
      } catch (error) {
        console.error(error);
        this.currentVenueName = "当前场馆";
      }
    },
      openSelectVenueDialog() {
        console.log('openSelectVenueDialog')
        this.selectVenueDialogVisible = true;
      },
      submitSelectVenueDialog(res) {
        console.log('submitSelectVenueDialog')
        this.selectVenueDialogVisible = false;
        this.checkStep(res);
      },
      cancelSelectVenueDialog() {
        console.log('cancelSelectVenueDialog')
        this.selectVenueDialogVisible = false;
      },
      async checkStep(result){
      // 步骤 0:去场馆选择1:去注册资料填写2:去注册资料审核3:去展会列表
      console.log('checkStep === ',result)
      let { step } = result;
      setStep(step);
      if(step === "0"){
        // this.openSelectVenueDialog()
        console.log('按理走不到这里，报错')
      }else if(step === "1"){
       localStorage.setItem("currentExhibitionGuid", '');
       localStorage.setItem("currentExhibitionName", '');
       this.$store.dispatch('user/setCurrentExhibitionName', '');
       if(window.location.href.includes('/home/index')){
         window.location.reload(); // 刷新页面
       }
       this.$router.push({ path: "/home/index",}, () => {
         window.location.reload();
       });
      }else if(step === "2"){
        localStorage.setItem("currentExhibitionGuid", '');
        localStorage.setItem("currentExhibitionName", '');
        this.$store.dispatch('user/setCurrentExhibitionName', '');
        if(window.location.href.includes('/home/index')){
          window.location.reload(); // 刷新页面
        }
        this.$router.push({ path: "/home/index",}, () => {
          window.location.reload();
        });
      }else if(step === "3"){
        // this.$router.push({ path: "/home/index",});
        const currentExhibitionGuid = localStorage.getItem("currentExhibitionGuid");
        console.log('currentExhibitionGuid === ',currentExhibitionGuid)
        if(currentExhibitionGuid){
            try {
              const opt = new FormData();
              opt.append("exhibitionGuid", currentExhibitionGuid);
              const res = await switchCurrentExhibitionApi(opt);
              console.log('设置展会成功返回 ',res)
              if(res){
                localStorage.setItem("currentExhibitionGuid", res.guid);
                localStorage.setItem("currentExhibitionName", res.title);
                localStorage.setItem("exhibitionManageMethod", res.manageMethod || '0');
                this.$store.dispatch('user/setCurrentExhibitionName', res.title);
                if(window.location.href.includes('/home/index')){
                  window.location.reload(); // 刷新页面
                }else{
                  this.$router.push({ path: "/home/index",},
                  () => {
                    window.location.reload(); // 刷新页面
                  }
                  );
                }
              }else{
                localStorage.setItem("currentExhibitionGuid", '');
                localStorage.setItem("currentExhibitionName", '');
                this.$store.dispatch('user/setCurrentExhibitionName', '');
                if(window.location.href.includes('/home/index')){
                  window.location.reload(); // 刷新页面
                }else{
                  this.$router.push({ path: "/home/index",},
                  () => {
                    window.location.reload(); // 刷新页面
                  }
                  )
                }
              }
              
            } catch (error) {
              console.log('设置展会失败返回 ',error)
              if(window.location.href.includes('/home/index')){
                window.location.reload(); // 刷新页面
              }else{
                this.$router.push({ path: "/home/index",},
                () => {
                  window.location.reload(); // 刷新页面
                })
              }
            }

        }else{
          if(window.location.href.includes('/home/index')){
            window.location.reload(); // 刷新页面
          }else{
            this.$router.push({ path: "/home/index",},
            () => {
              window.location.reload(); // 刷新页面
            })
          }
        }
      }
      return;
    },
  },
}
</script>
<style lang="scss" scoped>
.right-actions-container {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 15px;
}
.avatar-container {
  .avatar-wrapper {
    padding: 5px 11px;
    position: relative;
    border: 1px solid rgba(255,255,255,0.4);
    border-radius: 4px;
    cursor: pointer;
    span{
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      font-weight: 400;
    }
    .el-icon-sort{
      font-size: 12px;
      margin-left: 2px;
      transform: rotate(90deg);
      color: #fff;
    }
  }
}
.currentExhibition {
  .avatar-wrapper {
    padding: 5px 11px;
    position: relative;
    // border: 1px solid rgba(255,255,255,0.4);
    // border-radius: 4px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    text-align: right;
    line-height: 22px;
    font-weight: 500;
  }
}
.exhibition-container {
  .avatar-wrapper {
    padding: 5px 11px;
    position: relative;
    border: 1px solid rgba(255,255,255,0.4);
    border-radius: 4px;
    cursor: pointer;
    span{
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      font-weight: 400;
    }
    .el-icon-sort{
      font-size: 12px;
      margin-left: 2px;
      transform: rotate(90deg);
      color: #fff;
    }
  }
}

.logo-menu-con{
  padding: 0 20px;
  display: flex;
  align-items: center;
  background-image: linear-gradient(90deg, #2674B4 14%, #3D84BD 86%);
  height: 56px;
  width: 100%;
  box-sizing: border-box;
  .logo-con{
    width: 170px;
    min-width: 170px;
    max-width: 170px;
    display: flex;
    align-items: center;
    .logo-img{
      height: 40px;
    }
    p{
      margin-left: 10px;
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }
}
.el-menu.el-menu--horizontal{
  border-bottom-style: none;
}
::v-deep .el-menu-item{
  padding: 7px 16px;
  font-size: 16px;
  border-radius: 4px;
  height: 38px;
  line-height: 20px;
  color: #ffffff;
}
::v-deep .el-menu-item{
  margin-right: 0px;
  font-size: 16px;
  &.is-active{
    background: #419ED4 !important;
  }
}
::v-deep .el-dropdown{
  color: #ffffff;
}
/* 修改el-menu的hover背景色 */
::v-deep .el-menu-item:hover,
::v-deep .el-submenu__title:hover {
  background-color: #419ED4 !important;
}

::v-deep .el-submenu__title i{
  color: #ffffff;
}
::v-deep .el-submenu__title{
  padding: 7px 16px;
  font-size: 16px;
  height: 38px;
  line-height: 17px;
  border-radius: 4px;
}

</style>
<style lang="scss">
.el-menu--popup{
  background: #FFFFFF !important;
  border: 1px solid rgba(223,224,226,1);
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
  border-radius: 4px;
  .el-menu-item{
    span{
      color:#333;
    }
    &:hover{
      background: #E9F1F7 !important;
    }
  }
}
</style>

